/** Nome exibido do módulo (rota `/diretoria`). */
export const DIRETORIA_MODULE_TITLE = 'Tela 10';

/** Destino do link “Clique aqui” no card de apoio Rique.Ia (Tela 10). */
export const DIRETORIA_RIQUE_IA_URL = 'https://rique.ia';
